var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategory9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 59,
    viewBox: "0 0 64 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5667 12.0211H56.0667C59.3333 12.0211 62 14.9685 62 18.5791V50.5583C62 54.1689 59.3333 57.1163 56.0667 57.1163H7.93333C4.66666 57.1163 2 54.1689 2 50.5583V18.5791C2 14.9685 4.66666 12.0211 7.93333 12.0211H17.4333V8.81584C17.4333 5.05792 20.2333 2 23.6 2H40.3667C43.7667 2 46.5333 5.09476 46.5333 8.81584V12.0211H46.5667Z",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8334 12.0585H23.1667V10.3638C23.1667 8.85323 24.3 7.60059 25.6667 7.60059H38.3C39.6667 7.60059 40.8 8.85323 40.8 10.3638V12.0585H40.8334Z",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6666 39.4321V43.1164C36.6666 44.5532 35.5999 45.7322 34.2999 45.7322H29.6666C28.3666 45.7322 27.2999 44.5532 27.2999 43.1164V39.4321H23.9666C22.6666 39.4321 21.5999 38.2531 21.5999 36.8163V31.732C21.5999 30.2952 22.6666 29.1162 23.9666 29.1162H27.2999V25.432C27.2999 23.9951 28.3666 22.8162 29.6666 22.8162H34.2999C35.5999 22.8162 36.6666 23.9951 36.6666 25.432V29.1162H39.9999C41.2999 29.1162 42.3666 30.2952 42.3666 31.732V36.8163C42.3666 38.2531 41.2999 39.4321 39.9999 39.4321H36.6666Z",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory9);
export default __webpack_public_path__ + "static/media/category9.a6ffd64bb9fa4bc857f68cad3d901633.svg";
export { ForwardRef as ReactComponent };